import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";

/**
 * Handles the redirect from Emergent Auth.
 * URL contains "#session_id=..." which we exchange server-side for our JWT.
 */
export default function AuthCallback() {
    const navigate = useNavigate();
    const { setSessionFromExchange } = useAuth();
    const processed = useRef(false);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;

        const fragment = window.location.hash || "";
        const m = fragment.match(/session_id=([^&]+)/);
        if (!m) {
            navigate("/attorney/auth", { replace: true });
            return;
        }
        const sessionId = decodeURIComponent(m[1]);

        (async () => {
            try {
                const { data } = await api.post("/auth/google/exchange", { session_id: sessionId });
                setSessionFromExchange(data);
                // Strip the fragment, redirect to dashboard
                window.history.replaceState(null, "", window.location.pathname);
                navigate(data.user.role === "admin" ? "/admin/dashboard" : "/attorney/dashboard", { replace: true });
            } catch (e) {
                navigate("/attorney/auth?google_error=1", { replace: true });
            }
        })();
    }, [navigate, setSessionFromExchange]);

    return (
        <div className="min-h-[60vh] flex flex-col items-center justify-center gap-3" data-testid="auth-callback">
            <Loader2 className="h-7 w-7 animate-spin text-primary" />
            <p className="text-sm text-muted-foreground">Signing you in…</p>
        </div>
    );
}
